export var MockData = {
    id: 1,
    langcode: 'de',
    type: 'newsletter',
    parent_field_name: 'field_paragraph_iaw',
    field_newsletter_type: 'unsubscribe',
    field_area_key: 'serviceHilfeFormular',
};
export var MockDataErrorRecipientNotFound = {
    message: 'Error while unsubscribe - recipient not found',
    errors: [
        {
            errorCode: 404,
            message: '{"_readableState":{"objectMode":false,"highWaterMark":16384,"buffer":{"head":null,"tail":null,"length":0},"length":0,"pipes":null,"pipesCount":0,"flowing":null,"ended":false,"endEmitted":false,"reading":false,"sync":false,"needReadable":false,"emittedReadable":false,"readableListening":false,"resumeScheduled":false,"emitClose":true,"autoDestroy":false,"destroyed":false,"defaultEncoding":"utf8","awaitDrainWriters":null,"multiAwaitDrain":false,"readingMore":false,"decoder":null,"encoding":null},"readable":true,"_events":{"error":[null,null]},"_eventsCount":5,"_writableState":{"objectMode":false,"highWaterMark":16384,"finalCalled":false,"needDrain":false,"ending":false,"ended":false,"finished":false,"destroyed":false,"decodeStrings":true,"defaultEncoding":"utf8","length":0,"writing":false,"corked":0,"sync":true,"bufferProcessing":false,"writecb":null,"writelen":0,"afterWriteTickInfo":null,"bufferedRequest":null,"lastBufferedRequest":null,"pendingcb":0,"prefinished":false,"errorEmitted":false,"emitClose":true,"autoDestroy":false,"bufferedRequestCount":0,"corkedRequestsFree":{"next":null,"entry":null}},"writable":true,"allowHalfOpen":true,"_transformState":{"needTransform":false,"transforming":false,"writecb":null,"writechunk":null,"writeencoding":null}}',
        },
    ],
};
export var MockDataUnknownType = {
    message: 'request.body.type should be equal to one of the allowed values: pause, unsubscribe, frequency',
    errors: [
        {
            path: '.body.type',
            message: 'should be equal to one of the allowed values: pause, unsubscribe, frequency',
            errorCode: 'enum.openapi.validation',
        },
    ],
};
export var MockDataSuccessPause = {
    resultType: 'PAUSE_SUCCESSFUL',
    successful: true,
};
export var MockDataSuccessFrequency = {
    resultType: 'FREQUENCY_SUCCESSFUL',
    successful: true,
};
export var MockDataSuccessUnsubscribe = {
    resultType: 'UNSUBSCRIBE_SUCCESSFUL',
    successful: true,
};
//# sourceMappingURL=index.js.map